// Keeps queued uploads (with their File data) in IndexedDB so they resume after a reload, app switch or crash
const DB = "jixxeo-cloud-uploads";
const open = () => new Promise((ok, no) => {
  const r = indexedDB.open(DB, 1);
  r.onupgradeneeded = () => r.result.createObjectStore("q");
  r.onsuccess = () => ok(r.result);
  r.onerror = () => no(r.error);
});
const tx = async (mode, fn) => {
  const db = await open();
  return new Promise((ok, no) => {
    const t = db.transaction("q", mode);
    const res = fn(t.objectStore("q"));
    t.oncomplete = () => ok(res?.result);
    t.onerror = () => no(t.error);
  });
};

export const savePending = (key, row) => tx("readwrite", (s) => s.put({ key, file: row.file, opts: row.opts, name: row.name, size: row.size }, key)).catch(() => {});
export const dropPending = (key) => tx("readwrite", (s) => s.delete(key)).catch(() => {});
export const loadPending = () => tx("readonly", (s) => s.getAll()).then((x) => x || []).catch(() => []);
